module.exports = __webpack_public_path__ + "static/media/EHS-Lone-Worker-Policy.88f1ac78.pdf";